import { Component, OnDestroy, OnInit } from '@angular/core';
import {ProjectService} from '@catcore/services';
import {Project} from '@catcore/types/api-v2';
import {GenericLinkedResource} from '@catcore/types/base';
import {ProjectAvodCatalogService} from '@catmodels/avod-catalog/services/project-avod-catalog.service';
import {LinkItem, StyleType} from '@catui/types';
import {Subscription} from 'rxjs';
import {isNullOrUndefined} from 'util';
import {sortByLabelFunc} from "@catcore/utils";

@Component({
  selector: 'cat-project-avod-catalogs',
  templateUrl: './project-avod-catalogs.component.html',
  styleUrls: ['./project-avod-catalogs.component.scss'],
})
export class ProjectAvodCatalogsComponent implements OnInit, OnDestroy {

  styleType = StyleType;
  catalogItems: LinkItem[];
  project: Project = null;
  projectSubscription: Subscription = null;
  catalogSubscription: Subscription = null;
  resourceUri = '';
  catalog = {};
  creation = false;

  constructor(private service: ProjectAvodCatalogService,
              private projectService: ProjectService) {
  }

  ngOnInit() {
  this.projectSubscription = this
    .projectService
    .getCurrent()
    .subscribe((project: any) => {
      if (!isNullOrUndefined(project)) {
        this.project = project;
        this.updateCatalogs();
      }
    });
  }

  ngOnDestroy() {
    if (this.projectSubscription) {
      this.projectSubscription.unsubscribe();
    }
    if (this.catalogSubscription) {
      this.catalogSubscription.unsubscribe();
    }
  }

  selectedAvodCatalog(resourceUri: string) {
    this.creation = false;
    let _catalog: any = null;
    const subscription = this.service.getAvodCatalog(resourceUri).subscribe((catalog) => {
      _catalog = catalog;
      if (!isNullOrUndefined(_catalog)) {
        this.resourceUri = resourceUri;
        this.catalog = _catalog;
      }
      // subscription.unsubscribe();
    });
  }

  openCreateCatalogDialog($event) {
    this.creation = true;
  }

  creationComplete($event) {
    if ($event) {
      this.updateCatalogs();
    }
  }

  deleted($event) {
    this.updateCatalogs();
  }

  private updateCatalogs() {
    if (this.catalogSubscription) {
      this.catalogSubscription.unsubscribe();
    }
    this.catalogSubscription = this.projectService.getAllAvodCatalogs(this.project).subscribe((catalogs) => {
      if (!isNullOrUndefined(catalogs)) {
        const _catalogs = catalogs.map((catalog) => {
          const _label = catalog.name !== '' ? catalog.name + ' (' + catalog._links.service.label + ')' : 'Untitled (' + catalog._links.service.label + ')';
          return {label: _label, href: catalog._links.self.href};
        });
        this.catalogItems = this.buildItemsFromLinkedResources(_catalogs);
        this.catalogItems.sort(sortByLabelFunc);
      }
    });
  }

  private buildItemsFromLinkedResources(items: GenericLinkedResource[]): LinkItem[] {
    const options: LinkItem[] = [];
    items.forEach((item: GenericLinkedResource) => options.push({
      label: item.label,
      navigate: () => {
        this.selectedAvodCatalog(item.href);
      },
    }));
    return options;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/project-avod-catalogs/project-avod-catalogs.component.ts